/* eslint-disable no-console */
/* eslint-disable no-case-declarations */

import { SORT_CHAGE_FILTER, COLOR_CHANGE_FILTER, SEARCH_CHANGE_FILTER } from '../../../actions/analytics';
import { Utils } from '../../../utils/analytics/sendAnalyticsEvent';
import { buildSearchSortEvent, buildSearchColorChange, buildSearchTextChange } from './buildSearchSortEvent';

export const analyticssMiddleware = (state) => (next) => (action) => {
  switch (action?.type) {
  case SORT_CHAGE_FILTER:
    Utils.sendAnalyticsEvent(buildSearchSortEvent(action.payload));
    break;

  case COLOR_CHANGE_FILTER:
    Utils.sendAnalyticsEvent(buildSearchColorChange(action.payload));
    break;

  case SEARCH_CHANGE_FILTER:
    Utils.sendAnalyticsEvent(buildSearchTextChange(action.payload));
    break;

  default:
    next(action);
    break;
  }
};

export default analyticssMiddleware;
